import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4tkquuuvuh: FaireBrandEntity = {
  token: "b_4tkquuuvuh",
  type: "brand",
  name: "The Chocolate Shoppe",
  avatarUrl:
    "https://cdn.faire.com/fastly/7c85b76a563531320b4e475b998b9ec55bd28f8dda51119b0027f7d33aa13d5b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1e1d4068e3f85e6056da50a41894b5def6efec60be4af0f1a4623edddc472627.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7c85b76a563531320b4e475b998b9ec55bd28f8dda51119b0027f7d33aa13d5b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1e1d4068e3f85e6056da50a41894b5def6efec60be4af0f1a4623edddc472627.jpeg",
  location: "Plano, IL, USA",
  minimumOrderDollars: 277,
  rating: 5,
  reviewCount: 9,
  isInsider: true,
  description:
    "Premium Belgian truffles handcrafted for retailers, cafés, and gifting programs.\n\nThe Chocolate Shoppe is a specialty chocolatier located in the western suburbs of Chicago. Since 1997, our Master Chocolatier has created small-batch truffles and confections using classic techniques and premium Belgian chocolate.\n\nOur featured wholesale collection, CHOCOLUXE, combines timeless European flavor with modern presentation—beautifully boxed truffles that are shelf-stable and ready for retail display. From whimsical shapes like cupcakes and donuts to elegant assortments, each piece is hand-finished for a standout presentation in any shop or café.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:47.342Z",
    importedBy: "entity-db-cli",
  },
};
